export default "__VITE_ASSET__1befe6cf__"